export const fetchResource = (url: string): Promise<Record<string, unknown>> => {
    return fetch(url).then(response => {
        if (!response.ok) throw response

        return response.json()
    })
}

export const fetchWells = (): Promise<Record<string, unknown>> => {
    const url = '/services/plugin-wells/wells'

    return fetchResource(url)
}

export const fetchRigs = (): Promise<Record<string, unknown>> => {
    const url = '/services/plugin-liverig/assets/rig'

    return fetchResource(url)
}

export const fetchCrews = (): Promise<Record<string, unknown>> => {
    const url = 'services/plugin-liverig/assets/crew'

    return fetchResource(url)
}